import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import {
  DsTextIndicatorModule,
  DsTextIndicatorType,
} from '@design-system/components/text-indicator';
import { take } from 'rxjs';
import { DsSnackbarData } from './snackbar.models';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DsSpacingModule } from '@design-system/cdk/spacing';

@Component({
  selector: 'ds-snackbar',
  templateUrl: './snackbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    DsTextIndicatorModule,
    FlexLayoutModule,
    DsSpacingModule,
  ],
})
export class DsSnackbarComponent {
  type: DsTextIndicatorType;
  message: string;
  action?: string;
  snackbarRef: MatSnackBarRef<DsSnackbarComponent>;
  href?: string;

  private readonly _data: DsSnackbarData = inject(MAT_SNACK_BAR_DATA);

  constructor() {
    this.message = this._data.message;
    this.type = this._data.type || 'info';
    this.action = this._data.action || '';
    this.href = this._data.href;
    this._data.ref$.pipe(take(1)).subscribe((ref) => (this.snackbarRef = ref));
  }
}
